export default {"src":"/_next/static/media/processing-icon.d81b10ad.gif","height":44,"width":44};